const ChartDivideLine = () => {
    return (
        <div className="flex flex-col justify-center w-[1px]">
            <div className="bg-[#000000] w-full flex-1" />
            <div className="bg-[#9F9F9F] w-full flex-1" />
            <div className="bg-[#000000] w-full flex-1" />
            <div className="bg-[#9F9F9F] w-full flex-1" />
        </div>
    )
}

export default ChartDivideLine